<template>
    <div>
        <v-layout justify-center align-center wrap mt-3 v-if="items">
            <v-flex xs4 mx-1>
                <v-card color="white">
                    <v-layout justify-left align-center wrap>
                        <v-flex xs2 :key="items[0].loading">
                            <v-icon v-if="!items[0].loading" @click="generateCircuitNumbers()">autorenew</v-icon>
                            <v-progress-circular v-else size="20" indeterminate color="grey"></v-progress-circular>
                        </v-flex>
                        <v-flex xs3>
                            <h3 class="grey--text">{{items[0].name}}</h3>
                        </v-flex>
                        <v-flex xs6><span class="grey--text">{{items[0].description}}</span></v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
    
            <v-flex xs4 mx-1>
                <v-card color="white">
                    <v-layout justify-left align-center wrap>
                        <v-flex xs2 :key="items[1].loading">
                            <v-icon v-if="!items[1].loading" @click="updateServiceAccountCircuitNumbers(items[1])">autorenew</v-icon>
                            <v-progress-circular v-else size="20" indeterminate color="grey"></v-progress-circular>
                        </v-flex>
                        <v-flex xs3>
                            <h3 class="grey--text">{{items[1].name}}</h3>
                        </v-flex>
                        <v-flex xs6><span class="grey--text">{{items[1].description}}</span></v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
    
            <v-flex xs4 mx-1>
                <v-card color="white">
                    <v-layout justify-left align-center wrap>
                        <v-flex xs2 :key="items[2].loading">
                            <v-icon v-if="!items[2].loading" @click="uploadOrgLogoToAWS(items[2])">autorenew</v-icon>
                            <v-progress-circular v-else size="20" indeterminate color="grey"></v-progress-circular>
                        </v-flex>
                        <v-flex xs3>
                            <h3 class="grey--text">{{items[2].name}}</h3>
                        </v-flex>
                        <v-flex xs6><span class="grey--text">{{items[2].description}}</span></v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
    
            <v-flex xs4 mx-1>
                <v-card color="white">
                    <v-layout justify-left align-center wrap>
                        <v-flex xs2 :key="items[3].loading">
                            <v-icon v-if="!items[3].loading" @click="updateInstallPhotos(items[3])">autorenew</v-icon>
                            <v-progress-circular v-else size="20" indeterminate color="grey"></v-progress-circular>
                        </v-flex>
                        <v-flex xs3>
                            <h3 class="grey--text">{{items[3].name}}</h3>
                        </v-flex>
                        <v-flex xs6><span class="grey--text">{{items[3].description}}</span></v-flex>
                    </v-layout>
                </v-card>
            </v-flex>   
            
        </v-layout>
        <v-layout justify-center align-center wrap mt-3>
        <v-flex xs4 mx-1>
                <v-card color="white">
                    <v-layout justify-left align-center wrap>
                        <v-flex xs2 :key="items[4].loading">
                            <v-icon v-if="!items[4].loading" @click="generateCustomerOrgIds()">autorenew</v-icon>
                            <v-progress-circular v-else size="20" indeterminate color="grey"></v-progress-circular>
                        </v-flex>
                        <v-flex xs3>
                            <h3 class="grey--text">{{items[4].name}}</h3>
                        </v-flex>
                        <v-flex xs6><span class="grey--text">{{items[4].description}}</span></v-flex>
                    </v-layout>
                </v-card>
            </v-flex>

              <v-flex xs4 mx-1>
                <v-card color="white">
                    <v-layout justify-left align-center wrap>
                        <v-flex xs2 :key="items[5].loading">
                            <v-icon v-if="!items[5].loading" @click="generateRecurringAndOnceOffPrices()">autorenew</v-icon>
                            <v-progress-circular v-else size="20" indeterminate color="grey"></v-progress-circular>
                        </v-flex>
                        <v-flex xs3>
                            <h3 class="grey--text">{{items[5].name}}</h3>
                        </v-flex>
                        <v-flex xs6><span class="grey--text">{{items[5].description}}</span></v-flex>
                    </v-layout>
                </v-card>
            </v-flex>

             <v-flex xs4 mx-1>
                <v-card color="white">
                    <v-layout justify-left align-center wrap>
                        <v-flex xs2 :key="items[6].loading">
                            <v-icon v-if="!items[6].loading" @click="updateAllISPPackages(items[6])">autorenew</v-icon>
                            <v-progress-circular v-else size="20" indeterminate color="grey"></v-progress-circular>
                        </v-flex>
                        <v-flex xs3>
                            <h3 class="grey--text">{{items[6].name}}</h3>
                        </v-flex>
                        <v-flex xs6><span class="grey--text">{{items[6].description}}</span></v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
            </v-layout>
    </div>
</template>

<script>
import Api from '../services/Api'
export default {
    data() {
        return {
            items: [
                { name: 'Location Circuit Reference', description: 'Updates all location crcuit references based on Switchng centre & Network abbreviations.', loading: false },
                { name: 'Update Service Account Circuit No', description: 'Applies the location reference number and service account id to the circuit number.', loading: false },
                { name: 'Migrate all organisation logos to AWS S3', description: 'Sends base64 and uploads logo to s3 bucket', loading: false },
                { name: 'Migrate all install photos to AWS S3', description: 'Sends base64 and uploads photo to s3 bucket', loading: false },
                { name: 'Update all applications customer organisation id', description: 'Updates the customerOrganisationId to equal the customerOrganisationId attached to the packagesIsp.', loading: false },
                { name: 'Update all applications and service accounts package prices', description: 'Updates the recurring and once off prices.', loading: false },
                { name: 'Update all ISP Packages linked to templated', description: '', loading: false },


            ]
        }
    },
    methods: {
         async generateRecurringAndOnceOffPrices() {
            let allApplications = await this.fetchAllApplications()
            let data = allApplications.map(x => ({ id: x.id, ispRecurringPriceVatInc: x.packagesIsp.recurringPriceVatInc, ispOnceOffPriceVatInc: x.packagesIsp.onceOffPriceVatInc, primaryContactIdNumber: x.primaryContactIdNumber}))

            await Api().post("/applications/bulkUpdate/packagePrices", {
                batch: data,
            });
            let allServiceAccounts = []
            await allApplications.map(x=>{
                if(x.serviceAccountId != null){
                    allServiceAccounts.push({
                        id: x.serviceAccountId,
                        ispRecurringPriceVatInc: x.packagesIsp.recurringPriceVatInc
                    })
                }
                })
            await Api().post("/serviceAccounts/bulkUpdate/packagePrices", {
                batch: allServiceAccounts,
            });
        },
        async generateCustomerOrgIds() {
            let allApplications = await this.fetchAllApplications()
            let data = allApplications.map(x => ({ id: x.id, customerOrganisationId: x.packagesIsp.customerOrganisationId, primaryContactIdNumber: x.primaryContactIdNumber }))
            await Api().post("/applications/bulkUpdate/customerOrgId", {
                batch: data,
            });
        },
        async generateCircuitNumbers() {
            let allLocations = await this.fetchLocations()
            let data = allLocations.map(x => ({
                id: x.id,
                circuitNumber:
                    ((x.locationNetwork.locationNode.switchingCentre.upstreamSwitchingCentre) ?
                        ((x.locationNetwork.locationNode.switchingCentre.upstreamSwitchingCentre.upstreamSwitchingCentre) ?
                            ((x.locationNetwork.locationNode.switchingCentre.upstreamSwitchingCentre.upstreamSwitchingCentre.upstreamSwitchingCentre) ?
                                x.locationNetwork.locationNode.switchingCentre.upstreamSwitchingCentre.upstreamSwitchingCentre.upstreamSwitchingCentre.abbreviation :
                                x.locationNetwork.locationNode.switchingCentre.upstreamSwitchingCentre.upstreamSwitchingCentre.abbreviation) :
                            x.locationNetwork.locationNode.switchingCentre.upstreamSwitchingCentre.abbreviation) :
                        x.locationNetwork.locationNode.switchingCentre.abbreviation) + '/' + x.locationNetwork.abbreviation + x.id
            }))
            console.log(data)
            for (let i = 0; i < data.length; i++) {
                await Api().put('/locations/' + data[i].id, { circuitReference: data[i].circuitNumber })
            }
        },
        async fetchLocations() {
            let result = []
            debugger
            await Api()
                .get("/Locations/all")
                .then(response => {
                    result = response.data;
                })
            return result
        },
        async fetchAllApplications() {
            let result = []
            await Api().get('/applications/all').then(response => {
                result = response.data
            })
            return result
        },
        async fetchAllServiceAccounts() {
            let result = []
            debugger
            await Api().get('/serviceAccounts/all').then(response => {
                result = response.data.filter(x=>!x.circuitNumber && x.packagesIsp)
            })
            return result
        },
        async updateServiceAccountCircuitNumbers(item) {
            let index = this.items.indexOf(item)
            this.items[index].loading = true
            let allServiceAccounts = await this.fetchAllServiceAccounts()
            // let data = await response.data.map(x=>({id: x.id, circuitNumber: (x.id+'/'+x.packagesIsp.packagesFno.packagesFnoCat.abbreviation +'/'+x.location.circuitReference)}))
            let data = allServiceAccounts.map(x => ({ id: x.id, circuitNumber: (x.id + '/' + x.packagesIsp.packagesFno.packagesFnoCat.abbreviation + '/' + x.location.circuitReference) }))
            for (let i = 0; i < data.length; i++) {
                await Api().put('/serviceAccounts/' + data[i].id, { circuitNumber: data[i].circuitNumber })
            }
            this.items[index].loading = false
        },
        async fetchAllOrganisations() {
            let result = []
            await Api().get('/organisation').then(res => {
                result = res.data
            })
            return result
        },
        async uploadLogoImage(item) {
            await Api().post("/aws/s3/uploadLogo", { organisationId: item.id, data: item.logo, type: 'logo' })
        },
        async uploadInstallationImage(item) {
            await Api().post("/aws/s3/uploadInstallation", { organisationId: item.organisationId, data: item.data, type: item.type, installationId: item.id })
        },
        async uploadOrgLogoToAWS(item) {
            let index = this.items.indexOf(item)
            this.items[index].loading = true
            let orgs = await this.fetchAllOrganisations()

            for (let i = 0; i < orgs.length; i++) {
                if (orgs[i].logo && orgs[i].logo.includes('base64')) {
                    await this.uploadLogoImage(orgs[i])
                }
            }
            this.items[index].loading = false

        },
        async updateAllISPLinkedPackages(){
            await Api().get('/admin/packagesIsp/updateAllFromTemplates').then(()=>{

            })
        },

         async updateAllISPPackages(item) {
            let index = this.items.indexOf(item)
            this.items[index].loading = true
            await this.updateAllISPLinkedPackages()
            this.items[index].loading = false

        },
        async fetchAllInstallations() {
            let result = []
            await Api().get('/installations').then(res => {
                result = res.data
            })
            return result
        },
        async updateInstallPhotos(item) {
            let index = this.items.indexOf(item)
            this.items[index].loading = true
            let installs = await this.fetchAllInstallations()
            for (let i = 0; i, installs.length; i++) {
                if (installs[i].signOffSignature && installs[i].signOffSignature.includes('base64')) {
                    let obj = {
                        id: installs[i].id,
                        data: installs[i].signOffSignature,
                        type: 'signature',
                        organisationId: installs[i].organisationId
                    }
                    await this.uploadInstallationImage(obj)
                }

                if (installs[i].passiveInstallPhoto && installs[i].passiveInstallPhoto.includes('base64')) {
                    let obj = {
                        id: installs[i].id,
                        data: installs[i].passiveInstallPhoto,
                        type: 'passiveInstallPhoto',
                        organisationId: installs[i].organisationId
                    }
                    await this.uploadInstallationImage(obj)
                }

                if (installs[i].activeInstallPhoto && installs[i].activeInstallPhoto.includes('base64')) {
                    let obj = {
                        id: installs[i].id,
                        data: installs[i].activeInstallPhoto,
                        type: 'activeInstallPhoto',
                        organisationId: installs[i].organisationId
                    }
                    await this.uploadInstallationImage(obj)
                }
                if (installs[i].labellingPhoto && installs[i].labellingPhoto.includes('base64')) {
                    let obj = {
                        id: installs[i].id,
                        data: installs[i].labellingPhoto,
                        type: 'labellingPhoto',
                        organisationId: installs[i].organisationId
                    }
                    await this.uploadInstallationImage(obj)
                }

                if (installs[i].incompletePhoto && installs[i].incompletePhoto.includes('base64')) {
                    let obj = {
                        id: installs[i].id,
                        data: installs[i].incompletePhoto,
                        type: 'incompletePhoto',
                        organisationId: installs[i].organisationId
                    }
                    await this.uploadInstallationImage(obj)
                }

            }

            this.items[index].loading = false
        },
        async selectItem(item) {
            let index = this.items.indexOf(item)
            this.items[index].loading = true
            await item.function
            this.items[index].loading = false
        }
    }

}
</script>